import { AppBar, IconButton, Menu, MenuItem, Toolbar, Typography, useTheme } from "@mui/material"
import MenuIcon from "@mui/icons-material/Menu"
import HomeIcon from "@mui/icons-material/Home"
import AccountCircleIcon from "@mui/icons-material/AccountCircle"
import { useState } from "react"
import { logout } from "../api/auth"

interface HeaderProps {
    onToggleSidebar: () => void;
}

const Header: React.FC<HeaderProps> = ({ onToggleSidebar }) => {
    const theme = useTheme();
    const [menuAnchor, setMenuAnchor] = useState<null | HTMLElement>(null);

    const handleProfileClick = (e: React.MouseEvent<HTMLElement>) => {
        setMenuAnchor(e.currentTarget);
    };

    const handleMenuClose = () => {
        setMenuAnchor(null);
    };

    const handleLogout = () => {
        handleMenuClose();
        logout();
    };

    const handleGoHome = () => {
        window.location.href = import.meta.env.VITE_LOGIN_URL;
    };

    return (
        <AppBar
            position="static"
            sx={{
                backgroundColor: theme.palette.sidebar,
                color: theme.palette.sidebar,
            }}
            elevation={0}
        >
            <Toolbar sx={{ backgroundColor: theme.palette.sidebar.main, minHeight: '48px !important', height: 48 }} className="flex justify-between items-center px-4">
                {/* Left: Hamburger + Logo */}
                <div className="flex items-center space-x-2">
                    <IconButton
                        edge="start"
                        color="inherit"
                        aria-label="menu"
                        onClick={onToggleSidebar}
                        className="w-[28px] h-[28px] p-1"
                        sx={{ "&:focus": { outline: "none", boxShadow: "none" } }}
                    >
                        <MenuIcon className="text-white-800" fontSize="small" />
                    </IconButton>
                    <Typography variant="body1" sx={{
                        display: { xs: 'none', sm: 'block' },
                        fontFamily: theme.typography.heading?.fontFamily,
                        fontWeight: theme.typography.fontWeightBold,
                        color: theme.palette.primary[700],
                    }}>
                        Seguimiento de aplicaciones
                    </Typography>
                </div>

                {/* Right: Home + Perfil */}
                <div className="flex items-center space-x-1">
                    <IconButton
                        color="inherit"
                        aria-label="inicio"
                        onClick={handleGoHome}
                        sx={{ color: 'white', '&:focus': { outline: 'none', boxShadow: 'none' } }}
                    >
                        <HomeIcon fontSize="small" />
                    </IconButton>
                    <IconButton
                        color="inherit"
                        aria-label="perfil"
                        onClick={handleProfileClick}
                        sx={{ color: 'white', '&:focus': { outline: 'none', boxShadow: 'none' } }}
                    >
                        <AccountCircleIcon />
                    </IconButton>
                    <Menu
                        anchorEl={menuAnchor}
                        open={Boolean(menuAnchor)}
                        onClose={handleMenuClose}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                    >
                        <MenuItem onClick={handleLogout}>Cerrar sesión</MenuItem>
                    </Menu>
                </div>
            </Toolbar>
        </AppBar>
    );
}

export default Header